/** Static assets used in the top bar chrome. */
export const TOP_BAR_SEARCH_ICON_SRC = '/topbar/search.svg';
export const TOP_BAR_NOTIFICATION_BELL_SRC = '/topbar/notification-bell.svg';
export const TOP_BAR_SETTINGS_ICON_SRC = '/topbar/settings.svg';

/** Guardian account dropdown panel (narrow, provider list + profile). */
export const GUARDIAN_ACCOUNT_MENU_PANEL_CLASS =
  'absolute right-0 top-[calc(100%+8px)] z-20 min-w-[232px] max-w-[min(100vw-2rem,272px)] overflow-hidden rounded-xl border border-stroke-strong bg-white py-2 shadow-dropdown';

